<!-- Footer -->
<footer class="footer-bg pt-5 pb-4">
    <div class="container">
        <div class="row">
            <!-- Brand Column -->
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="footer-logo">
                    <img src="images/logo.svg" alt="" class="img-fluid">
                </div>
                <div class="social-link">
                    <a [href]="socialMediaLinks.instagram" target="_blank"><img src="images/instagram.svg" alt="" class="img-fluid"></a>
                    <a href="#" target="_blank"><img src="images/new-twitter.svg" alt="" class="img-fluid"></a>
                    <a [href]="socialMediaLinks.linkedin" target="_blank"><img src="images/linkedin-02.svg" alt="" class="img-fluid"></a>
                    <a  href="#" target="_blank"><img src="images/facebook-02.svg" alt="" class="img-fluid"></a>
                    <a [href]="socialMediaLinks.youtube" target="_blank"><img src="images/youtube.svg" alt="" class="img-fluid"></a>
                </div>
                <h6 class="title">Address</h6>
                <p class="footer-text">Registered Office <br>
                    LawSikho, Space Creattors Heights, 3rd floor,<br>
                    Landmark Cyber Park, Golf Course Extension, <br>
                    Sector 67,<br>
                    Gurgaon, Haryana - 122102</p>
            </div>

          <div class="col-lg-8 col-md-6 mb-4">
            <div class="row">
                  <!-- Company Column -->
            <div class="col-lg-4 col-md-6 mb-4">
                <h6 class="footer-heading">Company</h6>
                <ul>
                    <li><a (click)="navigateToRoute('/about-us')" class="footer-link">About</a></li>
                    <li><a (click)="navigateToRoute('/about-us')" class="footer-link">Our Team</a></li>
                    <!-- <li><a (click)="navigateToRoute('/coming-soon')" class="footer-link">Career</a></li>
                    <li><a (click)="navigateToRoute('/coming-soon')" class="footer-link">Investors</a></li> -->
                    <li><a (click)="navigateToRoute('/recommend-an-interview')" class="footer-link">Contact us</a></li>
                </ul>
            </div>

            <!-- Resources Column -->
            <div class="col-lg-4 col-md-6 mb-4">
                <h6 class="footer-heading">Resources</h6>
                <ul>
                    <li><a (click)="navigateToRoute('/interviews')" class="footer-link">Interviews</a></li>
                    <li><a (click)="navigateToRoute('/youtube-channel')" class="footer-link">Youtube Interviews</a></li>
                    <li><a (click)="navigateToRoute('/interviews/litigation')" class="footer-link">Litigation</a></li>
                    <li><a (click)="navigateToRoute('/interviews/deals-update')" class="footer-link">Deals Update</a></li>
                </ul>
            </div>

            
            <!-- Business Column -->
            <div class="col-lg-4 col-md-6 mb-4">
                <h6 class="footer-heading">Business</h6>
                <ul>
                    <li><a (click)="navigateToRoute('/recommend-an-interview')" class="footer-link">Suggest an Interview </a></li>
                    <li><a (click)="navigateToRoute('/coming-soon')" class="footer-link">Hire from us</a></li>
                </ul>
            </div>
            </div>
          </div>

        </div>

        <!-- Footer Bottom -->
        <div class="footer-bottom">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <p class="copyright-text mb-0">&copy; 2011 - 2025 ADDICTIVE LEARNING TECHNOLOGY LIMITED. All rights reserved.</p>
                </div>
                <div class="col-lg-6 col-md-12 text-lg-end text-md-center">
                    <div class="footer-bottom-links">
                        <a href="/privacy" class="me-4">Privacy Policy</a>
                        <a href="/terms" class="me-4">Terms of Service</a>
                        <a href="#">Cookies Settings</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
